import { CmsProvider, CmsIntegration } from "@modules/graphql/types"

type CmsConfig = { [key in unknown]?: { [key: string]: string } }
export type FormatCmsConfigurationOpts = CmsIntegration & CmsProvider
type CmsConfigurationRow = {
  name: string
  value: string | boolean
  url?: string
}

const CMS_CONFIG: CmsConfig = {
  CONTENTFUL: {
    spaceName: `Space`,
    spaceId: `Space Id`,
    url: `spaceName`,
  },
  DATOCMS: {
    projectName: `Project`,
    projectId: `Project Id`,
    url: `projectName`,
  },
  COSMICJS: {
    bucketSlugName: `Bucket`,
    bucketSlugId: `Bucket Id`,
    url: `bucketSlugName`,
  },
  SANITY: {
    projectId: `Project ID`,
    projectName: `Project Name`,
    dataset: `Dataset`,
    url: `projectName`,
  },
}

export const formatCmsConfiguration = ({
  config,
  features,
  vendor,
}: FormatCmsConfigurationOpts): CmsConfigurationRow[] => {
  const cmsConfig = []
  const vendorConf = CMS_CONFIG[vendor]

  if (config && vendorConf) {
    Object.entries(config).forEach(([key, value]) => {
      if (vendorConf[key]) {
        const configUrl = vendorConf[`url`] === key && {
          url: config.managementUrl || ``,
        }

        const cmsObj = {
          name: vendorConf[key],
          value,
          ...configUrl,
        }

        if (configUrl) cmsConfig.unshift(cmsObj)
        else cmsConfig.push(cmsObj)
      }
    })
  }

  if (features) {
    cmsConfig.push(
      {
        name: `Build Webhook`,
        value: !!features?.webhooks,
      },
      {
        name: `Environment Variables`,
        value: !!features?.envVars,
      },
      {
        name: `Preview Extension`,
        value: !!features?.extension,
      }
    )
  }

  return cmsConfig
}
